import { render, staticRenderFns } from "./CustomAttributesUpdateErrors.vue?vue&type=template&id=780d555a"
import script from "./CustomAttributesUpdateErrors.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesUpdateErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports